import { render, staticRenderFns } from "./SettingsGTM.vue?vue&type=template&id=b0832c42&scoped=true"
import script from "./SettingsGTM.vue?vue&type=script&lang=js"
export * from "./SettingsGTM.vue?vue&type=script&lang=js"
import style0 from "./SettingsGTM.vue?vue&type=style&index=0&id=b0832c42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0832c42",
  null
  
)

export default component.exports